import { Button, Space, Typography } from "antd";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDongleIpDetect } from "../../../hooks/useDongleIpDetect";

const DongleIpDetectToolbar = ({
  masterDeviceId,
  onDetectCompleted,
}: {
  masterDeviceId: string;
  onDetectCompleted?: () => void;
}) => {
  const { t } = useTranslation("settings");
  const deviceId =
    masterDeviceId && masterDeviceId !== "" ? masterDeviceId : undefined;
  const completedNotifiedRef = useRef(false);

  const { status, loading, error, startDetect, stopDetect, clearError } = useDongleIpDetect({
    deviceId,
    enabled: !!deviceId,
  });

  useEffect(() => {
    if (!status?.has_results) {
      completedNotifiedRef.current = false;
      return;
    }
    if (completedNotifiedRef.current) {
      return;
    }
    completedNotifiedRef.current = true;
    onDetectCompleted?.();
  }, [status?.has_results, onDetectCompleted]);

  if (!deviceId) {
    return (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {t(
          "home_settings_dongle_detect_no_master",
          "Select a master device to use autodetection.",
        )}
      </Typography.Text>
    );
  }

  return (
    <Space direction="vertical" size={4} style={{ minWidth: 200 }}>
      <Space wrap>
        <Button
          type="default"
          size="small"
          loading={loading}
          disabled={loading || !!status?.dongle_ip_detect}
          onClick={() => {
            clearError();
            startDetect();
          }}
        >
          {t("home_settings_dongle_autodetect", "Autodetect dongle")}
        </Button>
        <Button
          size="small"
          loading={loading}
          disabled={loading || !status?.dongle_ip_detect}
          onClick={() => {
            clearError();
            stopDetect();
          }}
        >
          {t("home_settings_dongle_autodetect_stop", "Stop")}
        </Button>
      </Space>
      {status?.dongle_status != null && status.dongle_status !== "" && (
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {t("home_settings_dongle_status_label", "Dongle status")}: {status.dongle_status}
        </Typography.Text>
      )}
      {error && (
        <Typography.Text type="danger" style={{ fontSize: 12 }}>
          {error}
        </Typography.Text>
      )}
    </Space>
  );
};

export default DongleIpDetectToolbar;
